import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
// import { AppContext } from "../app-context-provider";
import React from 'react';
// import { buttonStyle, ColorType } from "../helpers/style-helpers";
import FileTypeSelector from './filetype-selector';
import { getZip } from '../helpers/api-helpers';
import { ReactComponent as DownloadButton } from '../assets/images/download-arrow.svg';
// import LoadingSpinner from "./loading-spinner";
import AnimateHeight from 'react-animate-height';
import { FaRegHandPointer } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import { LangContext } from '../contexts/Lang';
export interface DownloadBarProps {
  selectedItems: any[];
  deSelectAll?: any;
  enableConversions: boolean;
  isMulti: boolean;
}

export const FileDownloadTypes = {};

export default function DownloadBar(props: DownloadBarProps) {
  const [downloadStatus, setDownloadStatus]: [number | null, Function] =
    useState(null);
  // const appContext = useContext(AppContext);
  const [selectedFileType, setSelectedFileType] = useState('original');
  const fileLabel = props.isMulti ? 'filene' : 'filen';
  const { globalPageData } = useContext(LangContext);
  return (
    <div className='download-bar-wrapper'>
      <AnimateHeight
        duration={500}
        height={props.selectedItems.length === 0 ? 'auto' : 0} // see props documentation below
      >
        <div className='download-bar'>
          <div className='download-bar_grid'>
            <div className='download-bar_box-icons'>
              {/* <BiCheckCircle size="2.5rem" />
               */}
              <i className='download-bar_box-icon'></i>
              <FaRegHandPointer
                size='2.5rem'
                className='download-bar_pointer-icon'
              />
            </div>
            <h4>
              {props.isMulti && (
                <>
                  {globalPageData.downloadMulti ||
                    'Klikk på filene du ønsker å laste ned:'}
                </>
              )}
              {!props.isMulti && (
                <>
                  {globalPageData.downloadSingle ||
                    'Klikk på filen du ønsker å laste ned:'}
                </>
              )}
            </h4>
          </div>
          {!props.enableConversions && (
            <p>
              {globalPageData.lastesNedIOriginalformat ||
                fileLabel.charAt(0).toUpperCase() +
                  fileLabel.slice(1) +
                  ' lastes ned i originalformat'}
            </p>
          )}
        </div>
      </AnimateHeight>
      <AnimateHeight
        duration={500}
        height={props.selectedItems.length !== 0 ? 'auto' : 1} // see props documentation below
      >
        <div className='download-bar'>
          {props.enableConversions && (
            <FileTypeSelector
              setSelectedFileType={setSelectedFileType}
              original={
                props.selectedItems.length > 0
                  ? '(' +
                    props.selectedItems
                      .map((item, index) =>
                        index === 0 ? '.' + item.file?.extension : ''
                      )
                      .toString()
                      .replace(/,/g, '') +
                    ')'
                  : ''
              }
              selected={selectedFileType}
            />
          )}

          {downloadStatus === null && (
            <div className='download-bar_button-grid'>
              <div>
                {props.isMulti && (
                  <div className='download-bar_chosen-files-text'>
                    <label>
                      {globalPageData.valgteFiler || 'Valgte filer:'}
                      {props.selectedItems.length}
                    </label>
                  </div>
                )}
                <button
                  className={`download-zip-button ${
                    props.selectedItems.length !== 0
                      ? 'download-zip-button-reveal'
                      : 'download-zip-button-hide'
                  } ${
                    props.selectedItems.length > 1
                      ? 'download-zip-button-multiple'
                      : 'download-zip-button-single'
                  }`}
                  disabled={downloadStatus !== null}
                  onClick={() => {
                    setDownloadStatus(0);
                    getZip(
                      props.selectedItems.map((item) => item.file?.id),
                      selectedFileType,
                      props.selectedItems
                        .map((item) => item.file?.slug)
                        .toString(),
                      (recievedPercent: number) => {
                        console.log(recievedPercent);
                        setDownloadStatus(recievedPercent);
                      },
                      () => setDownloadStatus(null)
                    );
                  }}>
                  {/* {props.selectedItems.length > 1 ? <span>Download all as .zip</span> : <span>Download file</span>} */}
                  <DownloadButton />
                </button>
              </div>
              <div>
                {!props.isMulti && (
                  <div>
                    <label
                      style={{
                        marginBottom: '1rem',
                        display: 'block',
                      }}>
                      {globalPageData.trykkForALasteNed ||
                        'Trykk for å laste ned:'}
                    </label>
                    <div>
                      {props.selectedItems.map((item) => (
                        <span key={item.key} className='badge'>
                          {item.title +
                            (selectedFileType.toLowerCase() === 'original'
                              ? '.' + item.file?.extension
                              : selectedFileType)}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {props.isMulti && (
                  <AnimatePresence>
                    {props.selectedItems.map(
                      (item, index) =>
                        item && (
                          <motion.span
                            initial={{
                              opacity: 0,
                              y: 10,
                            }}
                            animate={{
                              opacity: 1,
                              y: 0,
                            }}
                            // exit={{
                            //   opacity: 0,
                            //   y: -10,
                            // }}
                            transition={{
                              duration: 0.2,
                            }}
                            className='badge'
                            key={selectedFileType + item.key + 'badge'}>
                            {item.title}
                            {selectedFileType.toLowerCase() === 'original'
                              ? '.' + item.file?.extension
                              : selectedFileType}
                          </motion.span>
                        )
                    )}
                  </AnimatePresence>
                )}

                <div style={{ width: '100%' }}>
                  <button
                    className='download-reset-btn'
                    onClick={props.deSelectAll}>
                    {globalPageData.fjernValgteFiler || 'Fjern valgte filer'}
                    <FontAwesomeIcon icon={faUndo} />
                  </button>
                </div>
              </div>
            </div>
          )}
          {downloadStatus === 0 && (
            <p>
              {globalPageData.filerGjoresKlare ||
                'Filene dine gjøres klar for nedlasting, vennligst vent et øyeblikk.'}
            </p>
          )}
          {downloadStatus !== null && downloadStatus > 0 && (
            <span>
              {globalPageData.lasterNed || 'Laster ned...'}
              {downloadStatus}%
            </span>
          )}
        </div>
      </AnimateHeight>
    </div>
  );
}
